<template>
  <div class="index-query-dataen" style="height: calc(100% - 175px)">
    <div class="copySel">
      <!-- <base-form ref="queryForm" 
                v-model="baseQueryFormObj" 
                labelWidth="120px"
                :inline="true" 
                :form-items="baseFormItems">
            </base-form> -->
    </div>
    <base-form
      ref="queryForm"
      style="margin-top: -20px"
      v-model="queryFormObj"
      labelWidth="120px"
      :inline="true"
      @keyup.enter.native="enterQuery"
      :form-items="toolbar.formItems"
    >
    </base-form>
    <base-table-new
      :sendJson="true"
      :isSendToken="false"
      ref="table"
      :query="queryFormObj"
      :initSearch="false"
      :actionReload="true"
      url="queryData/getEn"
      :columns="columns"
      :responseHandler="responseHandler"
    >
    </base-table-new>
  </div>
</template>
<script>
export default {
  name: 'index-query-data',
  data() {
    var brandQueryForm = {
      label: ' 列表类别',
      prop: 'bid',
      labelWidth: '200px',
      component: 'form-select1',
      bind: {
        param: {
          data_type: 1,
        },
        clearable: true,
        sendJson: true,
        isSendToken: false,
        dataKey: {
          label: 'brand',
          value: 'id',
        },
      },
      on: {
        change: this.brandChange,
      },
    }
    return {
      showImportDialog: false,
      userArr: [],
      currSelectIdx: -1,
      baseQueryFormObj: {},
      queryFormObj: {},
      // type:'',
      brandQueryForm: brandQueryForm,
      toolbar: {
        formItems: [],
        query: {},
      },
      baseFormItems: [
        {
          label: '查询类型',
          prop: 'type',
          component: 'form-select',
          bind: {
            options: this.$getOptions('queryType'),
          },
          on: {
            change: this.typeChange,
          },
        },
        brandQueryForm,
      ],
      columns: [],
    }
  },
  methods: {
    success() {},
    enterQuery() {
      this.$refs.table.query.PageIndex = 1
      this.$refs.table.refreshData()
    },
    typeChange(val) {
      var that = this
      var firstFormItem = { ...this.brandQueryForm }
      firstFormItem.bind.url = 'brandOrField/get'
      firstFormItem.bind.param.type = val
      firstFormItem.value = ''
      this.toolbar.formItems = []
      this.columns = []
      this.baseFormItems.splice(1, 1)
      this.$nextTick(() => {
        this.baseFormItems[0].value = val
        this.baseFormItems.push(firstFormItem)
      })
      //console.log(this.baseFormItems)
    },
    queryOptions(data) {
      var i = 0
      var formItems = this.toolbar.formItems
      if (!data) {
        var fields = []
        for (var item of formItems) {
          if (this.currSelectIdx < 0 || i > this.currSelectIdx) {
            if (item.component == 'form-select') {
              fields.push(item.prop)
            }
          }
          i++
        }
        if (fields.length == 0) return
        data = { ...this.queryFormObj, fields: fields.join(',') }
        delete data['PageSize']
        delete data['PageIndex']
      }
      var that = this
      var url = 'queryData/getFileDisdDataEn'
      that.$postObj(url, data, {}, {}, false).then(function (resp) {
        if (resp.data.code == 0) {
          var data = resp.data.data
          i = 0
          for (var item of formItems) {
            if (that.currSelectIdx < 0 || i > that.currSelectIdx) {
              item.bind.options = []
              var optionsArr = data[item.prop]
              if (optionsArr) {
                for (var optionObj of optionsArr) {
                  if (optionObj) {
                    item.bind.options.push({
                      label: optionObj,
                      value: optionObj,
                    })
                  }
                }
              }
            }
            i++
          }
        } else {
          that.$message(resp.data.msg)
        }
      })
    },
    removeReadOnly() {
      var seles = document.getElementsByClassName('el-select el-select--small')
      for (var obj of seles) {
        obj.getElementsByTagName('input')[0].removeAttribute('readonly')
      }
    },
    brandChange(objVal) {
      if (!objVal.val) {
        this.toolbar.formItems = []
        this.columns = []
        return
      }
      var that = this
      var url = 'brandOrField/getFiledEn'
      var data = {
        bid: objVal.val,
      }
      this.$post(url, data, {}, {}, false).then((resp) => {
        if (resp.data.code == 0) {
          that.currSelectIdx = -1
          var data = resp.data.data
          if (data && data.length > 0) {
            that.queryFormObj = {
              PageIndex: that.queryFormObj.PageIndex,
              PageSize: that.queryFormObj.PageSize,
            }
            that.brandQueryForm.value = objVal.val
            var clum = [],
              queryFormItem = []
            var fields = data
            var i = 0
            for (var obj of fields) {
              //替换成英列名
              var fieldLabel = this.$store.state.tpmsfieldmap[obj.clum_name]
              if (fieldLabel) {
                obj.clum_desc = fieldLabel
              }

              if (obj.query_clum) {
                if (obj.ele_type) {
                  let clumProp = obj.clum_name
                  if (clumProp !== 'field10' && clumProp !=='field11') {
                      queryFormItem.push({
                      label: obj.clum_desc,
                      prop: obj.clum_name,
                      labelWidth: 'auto',
                      bind: {
                        placeholder: 'Please enter',
                        style: 'min-width:210px;max-width:260px;',
                      },
                      on: {
                        input: () => {
                          clearTimeout(that.layElementQuery)
                          that.layElementQuery = setTimeout(() => {
                            that.$refs.table.query.PageIndex = 1
                            that.$refs.table.refreshData()
                            that.queryOptions()
                          }, 500)
                        },
                      },
                    })
                  }
                } else {
                  var changeEvt = function (val) {
                    that.currSelectIdx = this
                    that.queryFormObj[
                      that.toolbar.formItems[that.currSelectIdx].prop
                    ] = val
                    for (
                      var j = that.currSelectIdx + 1;
                      j < that.toolbar.formItems.length;
                      j++
                    ) {
                      if (
                        that.toolbar.formItems[j].component == 'form-select'
                      ) {
                        that.queryFormObj[that.toolbar.formItems[j].prop] = ''
                      }
                    }
                    that.$refs.table.query.PageIndex = 1
                    that.$refs.table.refreshData()
                    that.queryOptions()
                  }
                  queryFormItem.push({
                    label: obj.clum_desc,
                    prop: obj.clum_name,
                    labelWidth: '100px',
                    value: '',
                    component: 'form-select',
                    bind: {
                      placeholder: 'Please select',
                      clearable: true,
                      filterable: true,
                      options: [],
                    },
                    on: {
                      change: changeEvt.bind(i), //.native
                      'visible-change': (val) => {
                        if (val) {
                          var sels = document.getElementsByClassName(
                            'el-select-dropdown el-popper'
                          )
                          sels[sels.length - 1].style['min-width'] = '210px'
                          sels[sels.length - 1].style['max-width'] = '260px'
                        } else {
                          setTimeout(() => {
                            that.removeReadOnly()
                          }, 50)
                        }
                      },
                    },
                  })
                  // strs+=","+obj.clum_name
                }
                i++
              }
              var bind = {
                label: obj.clum_desc,
                prop: obj.clum_name,
                minWidth: 100
              }
              if (bind.label == 'Programming') {
                bind.minWidth = 120
              }
              if (bind.label == 'Year') {
                bind.minWidth = 135
              }

              const column = { bind }
              if(bind.label == 'Relearn') {
                column.header = {
                  component: 'relearn-header',
                  bind: { lang : 'EN'}
                }
              }
              clum.push(column)
            }

            // 零件号和印刷号合并
            queryFormItem.push({
                    label: 'Please enter',
                    prop: 'ext_field1',
                    labelWidth: 'auto',
                    bind: {
                      placeholder: 'OEM Sensor P/N or Number on OEM sensor',
                      style: 'min-width:300px;max-width:300px;',
                    },
                    on: {
                      input: () => {
                        clearTimeout(that.layElementQuery)
                        that.layElementQuery = setTimeout(() => {
                          that.$refs.table.query.PageIndex = 1
                          that.$refs.table.refreshData()
                          that.queryOptions()
                        }, 500)
                      },
                    },
                  })
                  
            that.toolbar.formItems = queryFormItem
            that.toolbar.formItems.forEach((element) => {
              if (element.label == '厂家') {
                element.label = 'Manufacturers'
              }
              if (element.label == '车型') {
                element.label = 'Models'
              }
              if (element.label == '印刷号') {
                element.label = 'Number on OEM sensor'
              }
              if (element.label == '地区') {
                element.label = 'Market'
              }
            })
            that.columns = clum
            that.$nextTick(() => {
              that.$refs.table.query.bid = '5fed490ab6f2ea1bd409246d' //that.baseQueryFormObj.bid
              //刷新数据
              that.$refs.table.refreshData()
              // var data={
              //     bid:objVal.val,
              //     fields:strs.substring(1)
              // };
              //查询options数据
              that.queryOptions()
              //清除select input readonly属性
              that.removeReadOnly()
            })
          }
        } else {
          that.$message(resp.data.msg)
        }
      })
    },
    responseHandler(resp) {
      var data = {
        rows: resp.data.data.Data || [],
        total: resp.data.data.Total || 0,
      }
      clearTimeout(this.contentWrapLayoutChange)
      this.contentWrapLayoutChange = setTimeout(() => {
        this.$refs.table.$refs.table.doLayout()
        // var contentWraps = document.getElementsByClassName('content-wrap')
        // if (contentWraps.length > 0) {
        //   contentWraps[0].style.paddingTop = '1px'
        // }
      }, 50)
      return data
    },
  },
  mounted() {
    //this.typeChange('tyrePressureFuncQuery');
    //console.log(this.quaryParm)
    //sc: 5fed490ab6f2ea1bd409246d
    //css: 60f7cc20800ce05a34643f7e
    var objVal = {
      lab: '胎压',
      val: '5fed490ab6f2ea1bd409246d',
    }
    this.brandChange(objVal)
    this.$setLang('en')
  },
}
</script>
<style lang="less">
.index-query-dataen {
  .copySel {
    display: flex;
    padding: 20px 0px;
  }

  .copyLab {
    margin-left: 54px;
    margin-right: 10px;
    padding-top: 5px;
    text-align: right;
    font-size: 14px;
    color: #606266;
  }

  .select-max {
    max-width: 300px;
  }
  .el-table .cell {
    word-break: normal;
  }
  .el-form--inline .el-form-item {
    margin-right: 0;
  }
}
</style>